/**
 * Open a mailto: URL in a new tab so the current page stays open
 * (browser may still hand off to the desktop mail app).
 * @param {string} mailtoHref
 * @returns {boolean} Whether a handoff was attempted without throwing
 */
export default function openMailtoPreferNewTab(mailtoHref) {
  if (!mailtoHref || typeof mailtoHref !== 'string') return false;
  try {
    const win = window.open(mailtoHref, '_blank', 'noopener,noreferrer');
    if (win) return true;
  } catch (e) {
    console.warn('[openMailtoPreferNewTab] window.open mailto failed:', e);
  }
  try {
    const link = document.createElement('a');
    link.href = mailtoHref;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (e2) {
    console.warn('[openMailtoPreferNewTab] anchor mailto failed:', e2);
    return false;
  }
}
